import "./MobileNavigationMenuSkeleton.scss";

export const MobileNavigationMenuSkeleton = () => {
  return (
    <>
      <div className="MobileNavigationMenuSkeleton__item" />
      <div className="MobileNavigationMenuSkeleton__item" />
      <div className="MobileNavigationMenuSkeleton__item" />
    </>
  );
};
